import { bootstrapPortal } from '@/shared/app/bootstrapPortal';
import OrrApp from './OrrApp';

import '@wk/components-react16/dist/all.min.css';
import '@/index.css';

bootstrapPortal(<OrrApp />);
